export type TimedTimesheet = { clockIn: string; clockOut: string | null; lunchBreaksJson?: string | null };
type Break = { startedAt: string; endedAt: string | null };
export function timesheetLunchBreaks(entry: TimedTimesheet): Break[] {
  return entry.lunchBreaksJson ? JSON.parse(entry.lunchBreaksJson) as Break[] : [];
}
export function timesheetIsOnLunch(entry: TimedTimesheet) {
  return !entry.clockOut && timesheetLunchBreaks(entry).some(period => !period.endedAt);
}
/** Preserve the recorded visit envelope while excluding explicitly linked lunch. */
export function timesheetWorkedMilliseconds(entry: TimedTimesheet, now: number) {
  const start = Date.parse(entry.clockIn), end = Date.parse(entry.clockOut ?? new Date(now).toISOString());
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return 0;
  const breaks = timesheetLunchBreaks(entry).map(period => ({ start: Math.max(start, Date.parse(period.startedAt)), end: Math.min(end, period.endedAt ? Date.parse(period.endedAt) : now) }))
    .filter(period => Number.isFinite(period.start) && Number.isFinite(period.end) && period.end > period.start).sort((a, b) => a.start - b.start);
  let cursor = start, unpaid = 0;
  for (const period of breaks) { unpaid += Math.max(0, period.end - Math.max(cursor, period.start)); cursor = Math.max(cursor, period.end); }
  return Math.max(0, end - start - unpaid);
}
